<div
  #carouselContainer
  class="carousel"
  tabindex="0"
  [style.max-width]="maxWidth"
  [style.height]="!maintainAspectRatio ? '100%' : 'auto'"
>
  <ul
    #carouselList
    class="carousel-list"
    role="listbox"
    [style.flex-direction]="orientation === 'rtl' ? 'row-reverse' : 'row'"
    [style.height]="!maintainAspectRatio ? '100%' : 'auto'"
  >
    <li
      #carouselSlide
      *ngFor="let slide of slidesList"
      class="carousel-slide"
      role="option"
      [style.padding-bottom]="maintainAspectRatio && proportion ? proportion + '%': '0px'"
      [style.height]="!maintainAspectRatio && slideHeight ? slideHeight : '0px'"
      (panleft)="onPan($event, carouselSlide)"
      (panright)="onPan($event, carouselSlide)"
      (panend)="onPanEnd($event, carouselSlide)"
      (pancancel)="onPanEnd($event, carouselSlide)"
    >
      <ng-container [ngTemplateOutlet]="slide.templateRef"></ng-container>
    </li>
  </ul>

  <button
    *ngIf="!hideArrows"
    nz-button
    nzShape="circle"
    type="button"
    tabindex="-1"
    [disabled]="!loop && currentIndex == 0"
    (click)="previous()"
  >
    <nz-icon nzType="arrow-left"></nz-icon>
  </button>
  <button
    *ngIf="!hideArrows"
    nz-button
    nzShape="circle"
    type="button"
    tabindex="-1"
    [disabled]="!loop && currentIndex == slidesList.length - 1"
    (click)="next()"
  >
    <nz-icon nzType="arrow-right"></nz-icon>
  </button>

  <div
    *ngIf="!hideIndicators"
    class="carousel-indicators"
    tabindex="-1"
    [style.flex-direction]="orientation === 'rtl' ? 'row-reverse' : 'row'"
  >
    <button
      *ngFor="let slide of slidesList; let i = index"
      type="button"
      tabindex="-1"
      class="carousel-indicator"
      [class.carousel-indicator-active]="i == currentIndex"
      [disabled]="i == currentIndex"
      (click)="slideTo(i)"
      (focus)="carouselContainer.focus()"
    ></button>
  </div>
</div>
